import React from "react";
import { Row } from "reactstrap";
import { ExerciseContent } from "./ExerciseContent";
import { ListeningContent } from "./ListeningContent";
import OpenButton from "../../components/buttons/OpenButton";
import SimpleModal from "../../components/modals/SimpleModal";
import { size } from "lodash";
import { Speaking } from "../quiz/speaking";
import { exerciseType } from "../../components/constants/constants";
import { ShowExerciseQuestions } from "./ShowExerciseQuestions";
import WritingQuestion from "./WritingQuestion";
import { TempHeader } from "../quiz/TempHeader";

export const Exercise = ({
  isReview,
  data,
  isStopTimer,
  setIsStopTimer,
  setIsonRecorder,
  timer,
  isOpenAdditionalResourceModal,
  setOpenAdditionalResourceModal,
  additionalResourceToggle,
  setSpeakingUrl,
  questions,
  currentPage,
  onblur,
  answers,
  visualizerToggle,
  onUpdate,
  EndGptResponse,
  Qblinker,
  IsGenerating,
  Createaudio,
  ChatgptError,
}) => {
  let scroll = "scroll";
  let q_scroll = "question_scroll";
  let writing_head = "";
  let wr_footer = "border-bottom-0";
  if (data?.task_type === exerciseType.LISTENING_TASK && !Createaudio) {
    q_scroll = "question_scroll audio_height";
  }
  if (data.task_type === exerciseType.WRITING_TASK) {
    scroll = "";
    q_scroll = "";
    wr_footer = "rounded-footer pb-2"
    writing_head = "bg-white rounded-header border border-bottom-0 row";
  }
  return (
    <div id={`${scroll}`} className={`${q_scroll}`}>
      <div className="Question__description">
        <div className={writing_head}>
          <TempHeader data={data} />
        </div>
        <Row className="border bg-white border-top-0 border-bottom-0 px-4 py-2">
          {ChatgptError? (

            <div className="text-danger fs-5 pt-3 text-center"
            dangerouslySetInnerHTML={{
              __html: ChatgptError,
            }}
            />
          )
          : data?.task_type === exerciseType.LISTENING_TASK && !Createaudio ? (
            <ListeningContent
              data={data}
              IsGenerating={IsGenerating}
            />
          ):(
            <ExerciseContent
            data={data}
            studentid={data.school_student_id}
            studentAssessmentId={data.student_assessment_id}
            isReview={isReview}
            visualizerToggle={visualizerToggle}
            onUpdate={onUpdate}
            />
          )}
        </Row>
      </div>
      <Row
        className={
          size(data.additional_resource) <= 0
            ? ""
            : "border bg-white border-top-0 border-bottom-0 px-4 py-2"
        }
      >
        {size(data.additional_resource) <= 0 ? (
          ""
        ) : (
          <div>
            <p className="quiz-bottom-border mb-3"></p>
            <span class="mt-3 mb-3">
              <strong> Additional question resource </strong>
              <OpenButton
                onClick={() =>
                  setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal)
                }
              />
            </span>
            <p className="quiz-bottom-border mt-3"></p>
          </div>
        )}

        <SimpleModal
          isOpen={isOpenAdditionalResourceModal}
          toggle={additionalResourceToggle}
          bodyContent={
            <div
              dangerouslySetInnerHTML={{
                __html: data.additional_resource,
              }}
            />
          }
          footerContent={
            <button
              type="submit"
              class="btn btn-sm mx-3 modal-button"
              onClick={additionalResourceToggle}
            >
              Close
            </button>
          }
        />
      </Row>
      <Row
        className={`border bg-white border-top-0 ${wr_footer} px-4`}
      >
        {data.task_type === exerciseType.SPEAKING_TASK ? (
          null
        ):
        data.task_type === exerciseType.PRONUNCIATION_TASK ? (
          <Speaking
            Studentname={data.school_student_name}
            speakingUrl={setSpeakingUrl}
            setIsonRecorder={setIsonRecorder}
            speaking_data={data.speaking_plain_text_for_ml}
            isReview={isReview}
            speakingResponseURL={data.listening_file_url}
          />
        ) : 
        data.task_type === exerciseType.WRITING_TASK ?(
          <WritingQuestion data={data} isReview={isReview} />
        ):
        (
          <div>
            <ShowExerciseQuestions
              questions={questions}
              currentPage={currentPage}
              onAnswer={onblur}
              isReview={isReview}
              answer={answers}
              status={data.status}
              data={data}
              onUpdate={onUpdate}
              EndGptResponse={EndGptResponse}
              Qblinker={Qblinker}
              IsGenerating={IsGenerating}
            />
          </div>
        )}
      </Row>
    </div>
  );
};
